import { useGetTreinseriesForToday } from "@/entities/treinserie";
import { useSyncLangsteRoutes } from "@/entities/utils/sync-langste-routes.ts";
import { TreinserieDisplay } from "@/features/infra/components/treinserie-display.tsx";
import { Button, ConfirmDialog, Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { useState } from "react";

export function SyncLangsteRoutes() {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const syncLangsteRoutes = useSyncLangsteRoutes();
    const { data: treinseriesForToday, refetch } = useGetTreinseriesForToday();

    function handleReset() {
        syncLangsteRoutes.mutate(undefined, {
            onSuccess: () => setConfirmOpen(false),
        });
    }

    return (
        <div className="grid gap-2">
            <h3 className="text-l text-content-emphasis">Informatie over de langste routes van treinseries </h3>
            <div className="flex items-center">
                <p>
                    Voor vandaag zijn er{" "}
                    <Tooltip>
                        <TooltipTrigger>
                            <b>{treinseriesForToday?.length ?? 0} unieke treinseries</b>
                        </TooltipTrigger>
                        <TooltipContent className="grid max-w-260 grid-cols-8 gap-x-1">
                            {treinseriesForToday?.map((treinserie) => (
                                <TreinserieDisplay
                                    key={treinserie}
                                    className="text-content-default-inverse grid grid-cols-[1fr_40px] justify-end gap-x-2"
                                    nummer={treinserie}
                                    variant="badge"
                                    badgeVariantOverride="default"
                                />
                            ))}
                        </TooltipContent>
                    </Tooltip>{" "}
                    gevonden.
                </p>
                <Button variant="tertiary" size="s" iconOnly icon="refresh" onClick={() => void refetch()} title="Opnieuw ophalen" />
            </div>
            <div>
                <Button variant="secondary" onClick={() => setConfirmOpen(true)}>
                    Synchroniseer langste routes
                </Button>
            </div>

            <ConfirmDialog
                isOpen={confirmOpen}
                onCancel={() => setConfirmOpen(false)}
                onConfirm={handleReset}
                isPending={syncLangsteRoutes.isPending}
                error={syncLangsteRoutes.error}
                title="Synchroniseer langste routes"
            >
                Let op! Langste routes worden dagelijks opgehaald met een job, dus hoeven <i>in principe</i> niet handmatig opgehaald te
                worden. Indien het nodig is kan met deze knop wel een trigger verstuurd worden om alsnog de nieuwste data op te halen.
                Gebruik met gezond verstand!
            </ConfirmDialog>
        </div>
    );
}
